import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./QuestionsAndAnswers.module.scss";
import { Expander } from "../../../shared/components/Expander/Expander";
export const QuestionsAndAnswersGroup: React.FC<{
  group: any;
}> = t0 => {
  const $ = _c(10);
  const {
    group
  } = t0;
  const t1 = group._key || group._id;
  let t2;
  if ($[0] !== group.title) {
    t2 = <div className={styles.groupheader}><h4>{group.title}</h4></div>;
    $[0] = group.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== group.answers) {
    t3 = group.answers.map(_temp);
    $[2] = group.answers;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className={styles.groupanswers}>{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <><div className={styles.grid} key={t1}>{t2}{t4}</div></>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
function _temp(answer) {
  return <Expander key={answer._key} title={answer.question} content={answer.answer} linksTitle={answer.links_title} links={answer.links} />;
}